import { ApiError } from '@/lib/api'

/**
 * What a failed request says, honestly: the sentence for the API's status when the
 * action has one, else `fallback`. Never repeats what was sent.
 */
export function failureMessage(error: unknown, byStatus: Readonly<Partial<Record<number, string>>>, fallback: string): string {
  return (error instanceof ApiError ? byStatus[error.status] : undefined) ?? fallback
}
